import QuantityNumericInput from './QuantityNumericInput';

export default QuantityNumericInput;
